import { Component } from '@angular/core';

@Component({
  selector: 'app-denied-drawings',
  imports: [],
  templateUrl: './denied-drawings.component.html',
  styleUrl: './denied-drawings.component.scss'
})
export class DeniedDrawingsComponent {

}
